import { Image, ImageProps } from 'antd';
import placeholder from 'assets/placeholder-image.webp';

import styles from './index.module.css';

const Avatar = (props: ImageProps) => {
  const src = props.src || placeholder;
  return (
    <picture className={styles.avatar}>
      <Image {...props} src={src} fallback={placeholder} alt="Avatar" />
    </picture>
  );
};

export default Avatar;
